/**
 * Падение от переводчика браузера (техдолг 263): React удаляет свой текстовый узел
 * или вставляет что-то перед ним, а переводчик этот узел уже подменил на `<font>`.
 * Тогда экран ошибки подсказывает ученику, что именно помогает.
 *
 * По полям, а не `instanceof Error`: браузер бросает DOMException.
 */
export function isTranslatorCrash(error: unknown): boolean {
  if (typeof error !== 'object' || error === null) return false;
  const { name, message } = error as { name?: unknown; message?: unknown };
  return name === 'NotFoundError' && typeof message === 'string' && /removeChild|insertBefore/.test(message);
}
